<template>
  <popover
    :class="{ timepicker: true, 'is-small': small }"
    :width="width + 'rem'"
    :style="{ width: width - 1 + 'rem' }"
    placement="bottom-start"
    fixed
    :disabled="disabled"
  >
    <div slot="trigger" class="columns is-mobile is-gapless is-vcentered">
      <div class="column">
        <input
          v-model="hour"
          :class="{ input: true, 'is-small': small }"
          type="text"
          :disabled="disabled"
          maxlength="2"
          @focus="$event.target.select()"
          @input="focusMinuteOnValidHour"
        />
      </div>
      <div class="column is-narrow">:</div>
      <div class="column">
        <input
          ref="minute"
          v-model="minute"
          :class="{ input: true, 'is-small': small }"
          type="text"
          :disabled="disabled"
          maxlength="2"
          @focus="$event.target.select()"
        />
      </div>
    </div>

    <div
      v-for="suggestion in suggestions"
      :key="suggestion.str"
      :class="{ 'time-option': true, 'is-active': suggestion.str === str }"
      @click.prevent="set(suggestion)"
    >
      {{ suggestion.hour }} : {{ suggestion.minute }}
    </div>
  </popover>
</template>
<script>
const defaultValues = {
  hour: "00",
  minute: "00",
};

export default {
  name: "TimePicker",
  props: {
    time: {
      type: String,
      default: "00:00",
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    widthProp: {
      type: Number,
      default: false,
    },
  },
  data() {
    var { hour, minute } = this.parse(this.time);
    return {
      hour,
      minute,
      suggesting: false,
    };
  },
  computed: {
    width() {
      if (this.small) {
        return 5;
      }

      if (this.widthProp) {
        return this.widthProp;
      }

      return 7;
    },
    str() {
      return `${this.fixHour(this.hour)}:${this.fixMinute(this.minute)}`;
    },
    suggestions() {
      const suggestions = [];
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 30) {
          const hour = this.leftPad(h);
          const minute = this.leftPad(m);
          suggestions.push({
            str: `${hour}:${minute}`,
            hour,
            minute,
          });
        }
      }

      return suggestions;
    },
  },
  watch: {
    hour: "emitUpdate",
    minute: "emitUpdate",
    time() {
      this.parse(this.time);
    },
  },
  mounted() {
    this.emitUpdate();
  },
  methods: {
    leftPad(number) {
      const str = number.toString();
      return ("00" + str).substring(str.length);
    },
    validateHour(str) {
      return str.match(/^([0-1]?[0-9]|2[0-3])$/);
    },
    validateMinute(str) {
      return str.match(/^[0-5]?[0-9]|[0-9]$/);
    },
    fixHour(str) {
      if (str === "") {
        return "";
      }
      this.hour = this.validateHour(str) ? str : defaultValues.hour;
      return this.validateHour(str) ? str : defaultValues.hour;
    },
    fixMinute(str) {
      if (str === "") {
        return "";
      }
      this.minute = this.validateMinute(str) ? str : defaultValues.minute;
      return this.validateMinute(str) ? str : defaultValues.minute;
    },
    parse(str) {
      if (!str) {
        return defaultValues;
      }

      const values = str.split(":");
      if (values.length !== 2) {
        return defaultValues;
      }

      return {
        hour: this.fixHour(values[0]),
        minute: this.fixMinute(values[1]),
      };
    },
    set(obj) {
      this.hour = obj.hour;
      this.minute = obj.minute;
    },
    focusMinuteOnValidHour() {
      if (!this.hour.match(/^([0-1][0-9]|2[0-4])$/)) {
        return;
      }

      this.$refs.minute.focus();
    },
    emitUpdate() {
      this.$emit("update:time", this.str);
    },
  },
};
</script>
<style lang="scss">
.timepicker {
  box-shadow: inset 0 0 0 1px #dbdbdb;
  border-radius: 4px;

  .dashboard.is-dark & {
    background-color: #1f2128;
    box-shadow: inset 0 0 0 1px lighten(#1f2128, 15%);
  }

  &.is-active {
    border-color: #3273dc;
  }

  &.is-small {
    font-size: 0.75rem;
  }

  &.is-disabled {
    background-color: #f0f1fa;

    .dashboard.is-dark & {
      background-color: lighten(#1f2128, 5%);
    }
  }

  .popover__content {
    padding: 0.5rem;
    max-height: 10rem;
    overflow-y: scroll;
  }

  .column {
    &:last-child {
      margin-left: -1px !important;
    }
  }

  .input {
    text-align: center;
    border-radius: 4px;
    box-shadow: none;
    border: none;
    padding: 0;
    background-color: transparent !important;

    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}

.time-option {
  display: inline-block;
  padding: 0.25em;
  width: 100%;
  color: #374961;
  text-align: center;
  cursor: pointer;

  &:hover {
    background-color: #f0f1fa;
  }

  &.is-active {
    color: #3273dc !important;
  }

  .dashboard.is-dark & {
    color: #dddddf;

    &:hover {
      background-color: #1f2128;
    }
  }
}
</style>
